import geotags from "../store/modules/geotags";
import axios from "./HTTP";

export default {
  create(params, callback, errorCallback) {
    var nestedParams = {
      client_business: params.clientBusiness,
      geotagSelection: params.geotagSelection,
      worksiteGeotagSelection: params.worksiteGeotagSelection
    };
    nestedParams.client_business.worksites_attributes = [params.worksite];
    axios
      .post(`/api/client_businesses.json`, nestedParams)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getAll(userId, callback) {
    return axios
      .get("/api/client_businesses.json", { params: { user_id: userId } })
      .then(response => callback(response.data));
  },

  get(clientId, callback) {
    axios
      .get(`/api/client_businesses/${clientId}.json`)
      .then(response => callback(response.data));
  },

  update(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/client_businesses/${idAndFields.id}.json`, idAndFields)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getReviews(params, callback, errorCallback) {
    axios
      .get(`/api/client_businesses/${params.clientBusinessId}/reviews.json`)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  createReviewRequest(params, callback, errorCallback) {
    axios
      .post(`/api/location_reviews.json`, params)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  updateEvaluation(params, callback, errorCallback) {
    axios
      .patch(`/api/location_reviews/${params.id}/write.json`, {
        evaluation_write: params
      })
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getReviewDraft(shareKey, callback, errorCallback) {
    axios
      .get(`/api/location_reviews/${shareKey}.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  resendRequest(request, callback, errorCallback) {
    axios
      .post(`/api/location_reviews/${request.id}/resend_request.json`)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getReviewableEmployeesForLocation(locationId, callback, errorCallback) {
    axios
      .get(`/api/worksites/${locationId}/team_members.json?active_only=true`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  }
};
